// JamLabs dev with ThoughtSpot production (Charlie, 31 Oct): the same host,
// https://tpicaptca.dev.jamlabs.com, built with TCA_ENV=jld-prd. ?dashboards=thoughtspot shows
// ThoughtSpot PRD's liveboards, to compare with production Jitto at
// https://tradinganalytics.parametasolutions.com. Everything else is the jld build: sign-in is
// NPD's Okta app and every call goes to NPD's functions, because production's Okta app refuses
// this host's redirect and production's functions refuse its origin (CORS preflight, 31 Oct:
// empty Access-Control-Allow-Origin). ThoughtSpot is one instance, parameta.thoughtspot.cloud,
// so NPD's get-thoughtspot-token mints the signed-in user's token there and ThoughtSpot's own
// sharing decides which production liveboards and rows that user sees.
// ?dashboards=jitto is the jld Jitto tab (NPD Jitto), unchanged.
import jld from '../jld';
import prd from '../prd';

const config = {
  ...jld,
  thoughtSpotDashboards: prd.dashboards,
  thoughtSpotHost: prd.thoughtSpotHost,
};

export default config;
